import { render, staticRenderFns } from "./commonPick.vue?vue&type=template&id=47db6b8e&scoped=true&"
import script from "./commonPick.vue?vue&type=script&lang=js&"
export * from "./commonPick.vue?vue&type=script&lang=js&"
import style0 from "./commonPick.vue?vue&type=style&index=0&id=47db6b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db6b8e",
  null
  
)

export default component.exports